import React from "react";
import { styled } from "@mui/material/styles";

import MuiAppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Fab from "@mui/material/Fab";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import AccountCircle from "@mui/icons-material/AccountCircle";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { setPermission, setUser } from "../../store/actions";
import AuthService from "../../service/auth";

const Appbar = ({ open, toggleDrawer, title, configData = {}, loading = false }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user, permissions } = useSelector((state) => state);
  const UserName = `${user.currentUser.FirstName}`;
  const authService = new AuthService();
  const role = user.currentUser?.Role_id;

  const isMenuOpen = Boolean(anchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const logout = async () => {
    await authService.logout();
    handleMenuClose();
    dispatch(setUser(null));
    dispatch(setPermission([]));
    navigate((user.currentUser && (user.currentUser.isAdminOrEmp === 1 || role === 4)) ? "/admin" : "/");
  };

  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
      sx={{
        mt: configData.length > 0 ? "20px" : "30px",
      }}
    >
      <MenuItem onClick={() => navigate((user.currentUser && (user.currentUser.isAdminOrEmp === 1 || role === 4)) ? "/admin/my-profile" : "/my-profile")}>My Profile</MenuItem>
      <MenuItem onClick={logout}>Sign Out</MenuItem>
    </Menu>
  );

  return (
    <Box>
      <AppBar
        elevation={0}
        sx={{
          color: "black",
          backgroundColor: "white",
          boxShadow: "0px 3px 40px #4343430A",
          maxHeight: "45px !important",
          width: "100%",
          position: "relative",
        }}
        position="absolute"
        open={open}
      >
        <Toolbar
          sx={(theme) => ({
            display: "flex",
            pr: "24px", // keep right padding when drawer closed
            marginTop: "-10px",
            minHeight: "64px"
          })}
        >
          <Box
            sx={(theme) => ({
              marginRight: "24px",
              [theme.breakpoints.up("769")]: {
                display: "none",
              },
            })}
          >

          </Box>
          <Fab
            edge="start"
            onClick={toggleDrawer}
            size="small"
            sx={{
              backgroundColor: "white",
              marginRight: "36px",
              width: "25px",
              height: "25px",
              minHeight: "0px",
              margin: "10px 36px 10px 0",
            }}
          >
            {open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </Fab>
          <Grid container direction="row">
            <Grid item sm={12} xs={12} md={12} lg={12}>
              <Grid container direction="row">
                <Grid item sm={6} xs={6} md={6} lg={6} alignSelf="center">
                  <Typography component="h1" variant="h6" color="inherit" noWrap sx={{ flexGrow: 1 }}>
                    {title}
                  </Typography>
                </Grid>
                {/* Adding this changes for controling long names with wrapping */}
                <Grid
                  item
                  sm={6}
                  xs={6}
                  md={6}
                  lg={6}
                  textAlign="right"
                  alignSelf="center"
                  display={"flex"}
                  justifyContent={"flex-end"}
                >
                  <Typography component={"span"} noWrap sx={{ maxWidth: "400px", mt: "13px" }}>
                    {UserName}
                  </Typography>
                  <IconButton
                    color="inherit"
                    size="large"
                    edge="end"
                    aria-label="account of current user"
                    aria-haspopup="true"
                    onClick={handleProfileMenuOpen}
                  >
                    <AccountCircle />
                  </IconButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      {renderMenu}
    </Box>
  );
};

export default Appbar;

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    // marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));
